export const CallInsightsTeamsDashboards = {
  CallInsightsTeamsDashboards: {
    permissionsId: "c76322cb-2941-411c-7976-08dcaf947ea8",
    permissionsName: "Call Insights Teams",
    description: null,
    componentsId: null,
    components: null,
  },
};
